<template>
  <div class="home-page-box">

    <div class="home-page">
      <!-- 顶部 -->
      <homeHead ref="homeHead" :pages="notice" @homeBtn="searchBtn"></homeHead>
      <div class="home-page-content">

        <!-- 用户信息 -->
        <div class="home-user">
          <img :src="userInfo.logo" v-if="userInfo.logo != ''" class="home-user__avatar">
          <img v-if="userInfo.logo == ''" src="./../../../../assets/homeNew/default-header.png" class="home-user__avatar" />
          <div class="home-user__info">
            <div class="home-user__info__name">
              {{ greeting }}， {{ userInfo.userName }}
            </div>
            <div class="home-user__info__time">今天是{{today}}</div>
            <div class="home-user__info__notice">
              <img src="./../../../../assets/homeNew/tip.png" />
              <span>您有{{matterList[0].number}}条待办事项，请及时处理</span>
            </div>
          </div>
        </div>
        <!-- 事项、常用 -->
        <div class="home-item">
          <!-- 事项 -->
          <div class="home-items">
            <div class="home-card">
              <div class="home-card__header">
                <div class="home-card__header__title">
                  <img src="./../../../../assets/homeNew/wdsx-icon.png" />
                  <span>我的事项</span>
                </div>
                <div class="home-card__header__more" @click="allBtn">
                  <span>更多</span>
                  <img src="./../../../../assets/homeNew/arrow-right.png" />
                </div>
              </div>
              <div class="home-card__tabs">
                <div class="home-card__tabs__item" v-for="(item,index) in matterList" :class="matterIndex === index ? (index == 0 ? 'matterClass'  : (index === matterList.length - 1 ? 'matterClass2' :'matterClass1'))  : ''" :key="index" @click="matterBtn(item,index)">
                  <span> {{item.name}}({{ item.number }})</span>
                </div>

              </div>
              <div class="home-card__content height212" :style="{ borderTopLeftRadius: matterIndex === 0 ? '0px' : '', borderTopRightRadius: matterIndex === matterList.length - 1 ? '0px' : ''}">
                <div class="home-card__content--sub-title">

                  <div class="home-card__content--sub-title__item " :class="activeName == '1' ? 'is-active': ''" v-if="authType == 'A'" @click="handleClick('1')">待办</div>
                  <div class="home-card__content--sub-title__item" :class="activeName == '2' ? 'is-active': ''" v-if="authType == 'A'" @click="handleClick('2')">待阅</div>
                  <div class="home-card__content--sub-title__item" :class="activeName == '3' ? 'is-active': ''" v-if="authType == 'A'" @click="handleClick('3')">待认领</div>
                  <div class="home-card__content--sub-title__item" :class="activeName == '4' ? 'is-active': ''" v-if="authType == 'D'" @click="handleClick('4')">已办</div>
                  <div class="home-card__content--sub-title__item" :class="activeName == '5' ? 'is-active': ''" v-if="authType == 'D'" @click="handleClick('5')">已阅</div>

                  <div class="home-card__content--sub-title__item" :class="activeName == '6' ? 'is-active': ''" v-if="authType == 'C'" @click="handleClick('6')">已发起</div>
                  <div class="home-card__content--sub-title__item" :class="activeName == '7' ? 'is-active': ''" v-if="authType == 'C'" @click="handleClick('7')">已撤回</div>

                </div>
                <div class="article-padding-box" v-if="dataList.length > 0">
                  <div class="article-list-box  hairline-bottom" v-for="(item,index) in dataList" :key="index" @click="goDetail(item)">
                    <div class="icon"></div>
                    <div class="title">
                      {{item.title}}
                    </div>
                    <div class="time">
                      {{item.sendTime }}
                    </div>
                  </div>
                </div>
                <div class="no-wrap" v-else>
                  <img src="./../../../../assets/homes/nodatas.png" class="no-img" alt="">
                  <div class="no-title">
                    暂无数据
                  </div>
                </div>

              </div>
            </div>
          </div>
          <!-- 常用 -->
          <div class="home-favorite">
            <div class="home-card">
              <div class="home-card__header">
                <div class="home-card__header__title">
                  <img src="./../../../../assets/homeNew/favictor-icon.png" />
                  <span>常用应用</span>
                </div>
                <div class="home-card__header__more" @click="setBtn">
                  <span>设置应用</span>
                  <img src="./../../../../assets/homeNew/arrow-right.png" />
                </div>
              </div>
              <div class="home-card__content border-radius__16 height224 overflow-auto">
                <div class="home-card__content--wrapper ">

                  <el-carousel v-if="groupList.length" trigger="click" height="228px" :autoplay="false">
                    <el-carousel-item v-for="(group, idx) in groupList" :key="idx">

                      <div class="app-list">
                        <div class="app-list__item changyong" v-for="(item, index) in group" :key="index" @click="goData(item)">
                          <img :src="item.serviceIcon" alt="">

                          <span> {{ item.serviceName }}</span>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>

                  <div class="no-wrap" v-else>
                    <img src="./../../../../assets/homes/nodatas.png" class="no-img" alt="">
                    <div class="no-title">
                      暂无数据
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 应用服务 -->
        <div class="home-app">
          <div class="home-card">
            <div class="home-card__header">
              <div class="home-card__header__title">
                <img src="./../../../../assets/homeNew/yyfw-icon.png" />
                <span>应用服务</span>
              </div>
            </div>
            <div class="home-card__content border-radius__16  overflow-auto backgroundTr">
              <div class="home-card__content--wrapper ">
                <!-- 菜单 -->
                <div class="home-app-menu">
                  <div class="home-app-menu__item" v-for="(item,index) in allDataList" :key="index" :class="{ 'is-active': activeMenu == item.id }" @click="scrollToSection(item.id)">
                    <img src="./../../../../assets/homeNew/app-xzbg.png" />
                    <span> {{item.groupName}}</span>
                  </div>

                </div>
                <!-- 应用 -->

                <div class="app-list__content ">
                  <div class="app-list__wrapper" v-for="(item,index) in allDataList" :key="index">

                    <div class="app-list__title">
                      {{item.groupName}}
                    </div>
                    <div class="app-list__items" :id="item.id" v-if="item.serviceVOList.length > 0">
                      <div class="app-list">
                        <div class="app-list__item" v-for="(it, ind) in getDisplayedServices(item)" :key="ind" @click="goData(it)">
                          <img :src="it.serviceIcon" alt="">

                          <span> {{ it.serviceName }}</span>
                        </div>
                      </div>
                      <div v-if="item.serviceVOList.length > 5" class="more-btn" @click="toggleMore(item)">
                        <span>
                          {{ isShowMore(item) ? '收起' : '更多' }}
                        </span>
                      </div>
                    </div>
                    <div class="no-wrap" v-else>
                      <img src="./../../../../assets/homes/nodatas.png" class="no-img" alt="">
                      <div class="no-title">
                        暂无数据
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 动态、公告 -->
        <div class="home-feed">
          <!-- 动态 -->
          <div class="home-feeds">
            <div class="home-card">
              <div class="home-card__header">
                <div class="home-card__header__title">
                  <img src="./../../../../assets/homeNew/xwdt-icon.png" />
                  <span>新闻动态</span>
                </div>
                <div class="home-card__header__more" @click="goNewList">
                  <span>查看全部</span>
                  <img src="./../../../../assets/homeNew/arrow-right.png" />
                </div>
              </div>
              <div class="home-card__tabs">
                <div class="home-card__tabs__item " :class="newsTableIndex == index ? (index == 0 ? 'matterClass'  : (index === newsTableList.length - 1 ? 'matterClass2' :'matterClass1'))  : ''" v-for="(item,index) in newsTableList" :key="index" @click="tabNewClick(item,index)">
                  <span> {{ item.title }}</span>
                </div>

              </div>
              <div class="home-card__content" style="height: 242px;" :style="{ borderTopLeftRadius: newsTableIndex === 0 ? '0px' : '', borderTopRightRadius: newsTableIndex === newsTableList.length - 1 ? '0px' : ''}">

                <div class="article-padding-box" v-if="newsList.length > 0">
                  <div class="article-list-box hairline-bottom" v-for="(item,index) in newsList" :key="index" @click="goNew(item)">
                    <div class="icon"></div>
                    <div class="title">
                      {{item.title}}
                    </div>
                    <div class="time">
                      {{item.date }}
                    </div>
                  </div>
                </div>

                <div class="no-wrap" style="margin-top: 30px;" v-else>
                  <img src="./../../../../assets/homes/nodatas.png" class="no-img" alt="">
                  <div class="no-title">
                    暂无数据
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 通知公告 -->
          <div class="home-notice">
            <div class="home-card">
              <div class="home-card__header">
                <div class="home-card__header__title">
                  <img src="./../../../../assets/homeNew/tzgg-icon.png" />
                  <span>通知公告</span>
                </div>
                <div class="home-card__header__more" @click="goNotiList">
                  <span>查看全部</span>
                  <img src="./../../../../assets/homeNew/arrow-right.png" />
                </div>
              </div>
              <div class="home-card__content  border-radius__16 " style="height: 270px;">
                <div class="article-padding-box" v-if="noticeList.length > 0">
                  <div class="article-list-box hairline-bottom" v-for="(item,index) in noticeList" :key="index" @click="goNotice(item)">
                    <div class="icon"></div>
                    <div class="title">
                      {{item.title}}
                    </div>
                    <div class="time">
                      {{item.releaseTime  | analyseTime('1')}}
                    </div>
                  </div>
                </div>

                <div class="no-wrap" v-else>
                  <img src="./../../../../assets/homes/nodatas.png" class="no-img" alt="">
                  <div class="no-title">
                    暂无数据
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部 -->
        <homeFooter></homeFooter>

      </div>
      <div class="back-top-box tops-btn" @click="scrollToTop">

        <img src="./../../../../assets/homes/topsHei.png" class="tops-img" alt="">
        <img src="./../../../../assets/homes/topsWhite.png" class="tops-img-hover" alt="">
        <span class="back-top-box__text">回顶部</span>
      </div>
    </div>

    <drawerService ref="drawerService" :drawer="drawerShow" :arr="selectDataList" :list="allDataList" @call-parent-method="parentMethod" @cancel-parent-method="cancelMethod"></drawerService>
  </div>
</template>
<script>
import drawerService from './drawerService.vue'
import homeHead from '../../component/homeHead.vue'
import homeSearch from '../../component/homeSearch.vue'
import homeFooter from '../../component/homeFooter.vue'
import {
  getMyUserInfo, getDayWeather, getTodoCount, getMyQuickAppList, getTodoInfo, getServiceListByGroupType,
  getArticleListByType,
  getListByContentId,
  getTodoListManage

} from '../../../../api/api.p'
import { dateFormat } from '../../../../../src/libs/util'

import { fetchTodoList, } from './todoList'
import { analyseTime } from '../../../../components/filter'
// import { vMiniWeather, vMiniWeatherIcon } from 'vue-mini-weather'

import axios from 'axios';

export default {
  props: {},
  computed: {

    // 每页 8 条
    groupList () {
      const size = 8
      const list = this.selectDataList
      const groups = []
      for (let i = 0; i < list.length; i += size) {
        groups.push(list.slice(i, i + size))
      }
      return groups
    }
  },
  data () {
    return {
      greeting: '',        // 实时问候语
      today: '',            // 2025年10月23日 星期四
      drawerShow: false,
      selectDataList: [],
      allDataList: [],

      dataList: [],
      pageNum: 1,
      pageSize: 3,
      total: 1,
      zongtiaoshu: 0,
      current: 0,
      authType: '',
      from: '',
      params: {
        userId: '',
        authType: '',
        title: '',
        flowName: '',
        nodeName: '',
        status: '',
        dataType: '',
        pageNumber: 1,
        numPerPage: 3
      },
      newsTableList: [
        {
          title: '学院新闻',
          wbcontentid: 153382,
        },
        {
          title: '院部动态',
          wbcontentid: 160844,
        },
        {
          title: '校园网公告',
          wbcontentid: 153383,
        },
      ],
      newsTableIndex: 0,
      newsList: [],


      input: '',

      matterIndex: 0,
      matterList: [
        {
          name: '我的待办',
          authType: 'A',
          number: 0,
          from: 'flowTodo',
          indexs: 0,
        },
        {
          name: '我的已办',
          authType: 'D',
          number: 0,
          from: 'flowDone',
          indexs: 1,
        },
        {
          name: '我发起的',
          authType: 'C',
          number: 0,
          from: 'flowProgress',
          indexs: 2,
        },

      ],
      modelPass: {
        oldPass: '',
        newPass: '',
        affirmPass: '',
      },
      userInfo: {},

      noticeList: [],
      notice: 'home',
      days: '',
      routerIndex: 0,
      activeTab: '2',
      activeTab2: '2',
      activeMenu: '', // 默认激活校园生活

      activeName: '',
      showMoreMap: {}, // 用于存储每个item的展开状态，key为item.id或index

      // 仅在“我的待办(A)”场景下，监听 localStorage.hzUniqueId
      hzUniqueIdPollTimer: null
    }
  },
  filters: {
    dateFormatFilter (val) {
      let str = ''
      str = val
        ? val.toString().length < 13
          ? dateFormat('yyyy-MM-dd hh:mm:ss', val + '000')
          : dateFormat('yyyy-MM-dd hh:mm:ss', val)
        : ''
      return str
    },
    // 状态
    filterStaus (val) {
      let str = ''
      str = val == 0 ? '教职工' : val == 1 ? '学生' : '其他'
      return str
    },
    // 身份
    filterClass (val) {
      let str = ''
      switch (val) {
        case 0:
          str = '教职工'
          break
        case 10:
          str = '本专科学生'
          break
        case 20:
          str = '研究生'
          break
        case 30:
          str = '校友'
          break
        case 99:
          str = '其他'
          break
      }
      return str
    },
    // 性别
    filterSex (val) {
      let str = ''
      str = val == 0 ? '女' : val == 1 ? '男' : '未知'
      return str
    },
    // 院系
    departmentFilter (val) {
      let str = ''
      switch (val) {
        case 0:
          str = '教职工'
          break
        case 10:
          str = '本专科学生'
          break
        case 20:
          str = '研究生'
          break
        case 30:
          str = '校友'
          break
        case 99:
          str = '其他'
          break
      }
      return str
    },
    // 专业
    specializedFilter (val) {
      let str = ''
      switch (val) {
        case 0:
          str = '教职工'
          break
        case 10:
          str = '本专科学生'
          break
        case 20:
          str = '研究生'
          break
        case 30:
          str = '校友'
          break
        case 99:
          str = '其他'
          break
      }
      return str
    },



  },
  components: {
    homeHead,
    homeFooter,
    drawerService,
    homeSearch
    // vMiniWeather,
    // vMiniWeatherIcon
  },
  created () {
    // storage 事件：用于监听来自“其他页面/窗口”的 localStorage 更新
    this._hzUniqueIdStorageListener = (event) => {
      try {
        if (!event || event.key !== 'hzUniqueId') return
        if (event.newValue == null) return
        if (this.authType !== 'A') return
        this.handleClick(this.activeName)
      } catch (e) {
        // 忽略监听异常，避免影响页面渲染
      }
    }
  },
  mounted () {


    this.scrollToTop()
    this.setDateTime()

    this.setGreeting()   // 首次计算
    this.getMyUserInfo()
    this.getTodoCount()
    this.matterBtn(this.matterList[0], 0);
    // this.getDayWeatherFun()
    this.getMyQuickAppListFun()
    this.getServiceListByGroupTypeFun()
    this.getArticleListByTypeFun()

    this.tabNewClick(this.newsTableList[0], 0)
    window.addEventListener('storage', this._hzUniqueIdStorageListener)

  },
  beforeDestroy () {
    try {
      window.removeEventListener('storage', this._hzUniqueIdStorageListener)
    } catch (e) { }
    this.stopHzUniqueIdWatch()
  },

  methods: {
    getDisplayedServices (item) {
      if (this.showMoreMap[item.id]) {
        return item.serviceVOList;
      } else {
        return item.serviceVOList.slice(0, 10);
      }
    },
    toggleMore (item) {
      // 切换对应item的展开状态
      this.$set(this.showMoreMap, item.id, !this.showMoreMap[item.id]);
    },
    isShowMore (item) {
      return !!this.showMoreMap[item.id];
    },
    setDateTime () {
      const now = new Date()
      // 1. 问候语
      const h = now.getHours()
      if (h < 12) this.greeting = '上午好'
      else if (h < 18) this.greeting = '下午好'
      else this.greeting = '晚上好'

      // 2. 日期 + 星期
      const y = now.getFullYear()
      const m = now.getMonth() + 1
      const d = now.getDate()
      const weekMap = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const week = weekMap[now.getDay()]
      this.today = `${y}年${m}月${d}日 ${week}`
    },
    setGreeting () {
      const h = new Date().getHours()
      if (h < 12) this.greeting = '上午好'
      else if (h < 18) this.greeting = '下午好'
      else this.greeting = '晚上好'
    },

    // 滚动到指定区域
    scrollToSection (sectionName) {
      this.activeMenu = sectionName;

      // 使用 nextTick 确保 DOM 更新后再滚动
      this.$nextTick(() => {
        const targetElement = document.getElementById(sectionName);
        console.log(targetElement, 'targetElement')
        if (targetElement) {
          // 获取滚动容器
          const scrollContainer = document.querySelector('.app-list__content');
          // console.log(scrollContainer, 'scrollContainer')
          if (scrollContainer) {
            // 计算目标元素相对于滚动容器的位置
            const containerRect = scrollContainer.getBoundingClientRect();
            const targetRect = targetElement.getBoundingClientRect();
            const scrollTop = scrollContainer.scrollTop + (targetRect.top - containerRect.top);
            // console.log(scrollTop, 'scrollTop')

            window.scrollTo({
              top: scrollTop + 140,        // 滚动到页面顶部
              left: 0,       // 可以设置横向位置，如果不需要可以忽略
              behavior: 'smooth' // 平滑滚动
            });


            // 平滑滚动到目标位置
            // scrollContainer.scrollTo({
            //   top: scrollTop,
            //   behavior: 'smooth'
            // });
          }
        }
      });
    },



    goNewList () {
      window.open('https://www.mxzy.edu.cn')
    },
    goNew (item) {
      let url = 'https://www.mxzy.edu.cn/info/' + item.treeid + '/' + item.id + '.htm'

      // console.log(url, '---')
      window.open(url)
    },
    getColorClass (authType) {
      return {
        aclor: authType === 'A',
        dclor: authType === 'D',
        cclor: authType === 'C',
        eclor: authType === 'E'
      };
    },
    scrollToTop () {
      window.scrollTo({
        top: 0,        // 滚动到页面顶部
        left: 0,       // 可以设置横向位置，如果不需要可以忽略
        behavior: 'smooth' // 平滑滚动
      });
    },
    initFun () {
      this.$refs.homeHead.init();
    },
    searchBtn (data) {

      this.$router.push({
        path: '/searchList',
        query: {
          title: data
        }
      })
    },
    allBtn () {
      this.$router.push({
        path: '/serviceList',
        query: {
          indexs: this.routerIndex
        }
      })
    },
    goNotice (item) {
      let ids = JSON.parse(JSON.stringify(item))
      this.$router.push({
        path: '/noticeDetail',
        query: {
          articleId: ids.id,
        }
      })
    },
    goData (item) {
      console.log(item.homeUrl, 'item.homeUrl')

      window.open(item.homeUrl)
      // window.location.href = item.homeUrl
    },
    goNotiList () {
      this.$router.push({
        path: '/noticeList',
        query: {

        }
      })
    },
    // 通知公告 
    async getArticleListByTypeFun (item) {

      let param = {
        type: '通知公告',
        title: '',
        pageNumber: 1,
        numPerPage: 7
      }
      const res = await getArticleListByType(param);
      if (res) {

        if (res.meta.code == 0) {
          this.noticeList = res.data.records;

        } else {
          this.$toast(res.meta.message);
        }

      } else {

        this.$toast('操作失败');
      }

    },


    parentMethod () {
      this.drawerShow = false;
      this.getMyQuickAppListFun()
    },
    setBtn () {
      this.drawerShow = true;
      this.$refs.drawerService.init()
    },
    cancelMethod () {
      this.drawerShow = false;
    },
    matterBtn (item, index) {
      this.matterIndex = index;

      this.authType = item.authType;
      this.activeName = '';


      if (item.authType == 'A') {
        this.activeName = '1'
        this.startHzUniqueIdWatch()
      } else if (item.authType == 'D') {
        this.activeName = '4'
        this.stopHzUniqueIdWatch()
      } else if (item.authType == 'C') {
        this.activeName = '6'
        this.stopHzUniqueIdWatch()
      }
      this.handleClick(this.activeName)
    },
    handleClick (item) {
      // console.log(tab)
      // console.log(tab, event);
      const targetIndex = item || this.activeName
      this.activeName = targetIndex;

      // 如果当前在“我的待办(A)”并且存在 hzUniqueId，则触发刷新并删除该字段
      const hzUniqueId = window.localStorage.getItem('hzUniqueId')
      if (hzUniqueId) {
        window.localStorage.removeItem('hzUniqueId')
      }

      this.dataList = []

      this.getTodoListManageFun();

    },
    startHzUniqueIdWatch () {
      if (this.hzUniqueIdPollTimer) return

      // 轮询兜底：确保同标签页内写入 localStorage 也能触发
      this.hzUniqueIdPollTimer = window.setInterval(() => {
        try {
          if (this.authType !== 'A') return
          if (window.localStorage.getItem('hzUniqueId')) {
            this.handleClick(this.activeName)
          }
        } catch (e) { }
      }, 1000)
    },
    stopHzUniqueIdWatch () {
      if (this.hzUniqueIdPollTimer) {
        window.clearInterval(this.hzUniqueIdPollTimer)
        this.hzUniqueIdPollTimer = null
      }
    },
    goDetail (item) {
      console.log(item)
      // this.getTodoInfo(item)
      let url = item.url
      window.open(url)
    },

    tabNewClick (item, index) {
      this.newsTableIndex = index;
      this.newsList = []
      this.getListByContentId(item.wbcontentid)
    },
    //owner=1882569276&contentid=153382&start=1&count=10'

    async getListByContentId (item) {

      let params = {
        owner: '1882569276',
        contentid: item,
        start: 0,
        count: 6
      }
      const res = await getListByContentId(params);
      if (res) {

        if (res.meta.code == 0) {
          this.newsList = res.data;

        } else {
          this.$toast(res.meta.message);
        }

      } else {

        this.$toast('操作失败');
      }

    },


    // 获取全量 
    async getServiceListByGroupTypeFun () {

      let params = {
        groupType: 'H_unify',
      }
      const res = await getServiceListByGroupType(params);
      if (res) {

        if (res.meta.code == 0) {
          this.allDataList = res.data;
          // this.scrollToSection(res.data[0].id)

        } else {
          this.$toast(res.meta.message);
        }

      } else {

        this.$toast('操作失败');
      }

    },

    // 获取我的应用
    async getMyQuickAppListFun () {
      let params = {
        orgId: ''
      }
      const res = await getMyQuickAppList(params);
      if (res) {

        if (res.meta.code == 0) {
          this.selectDataList = res.data;

        } else {
          this.$toast(res.meta.message);
        }

      } else {

        this.$toast('操作失败');
      }

    },


    /*获取事项列表*/

    async getTodoListManageFun () {
      let param = {};
      param.pageNumber = 1;
      param.numPerPage = 5

      let res = await getTodoListManage(param, this.activeName);

      if (res != undefined) {
        if (res.meta.code == 0) {
          let data = res.data.records
          console.log(data)
          this.dataList = data.slice(0, 5);

        }

      }


    },

    // 事项 数量
    async getTodoCount () {

      let params = {
        dataType: '',
        userId: '',
      }
      const res = await getTodoCount(params)
      if (res) {
        if (res.meta.code == 0) {
          let data = res.data;
          this.matterList[0].number = data.todoCount
          this.matterList[1].number = data.doneCount
          this.matterList[2].number = data.createCount
          // this.matterList[3].number = data.endNum//办结事项
        } else {
          this.$toast(res.meta.message);
        }
      } else {
        this.$toast('操作失败');
      }
    },

    //天气
    getDayWeatherFun () {

      getDayWeather()
        .then((res) => {
          if (res.meta.code == 0) {
            this.days = res.data;

          } else {
            this.$toast(res.meta.message)
          }
        })
        .catch((err) => {
          this.$toast(err.meta.message)
        })
    },

    // 个人信息
    getMyUserInfo () {
      getMyUserInfo()
        .then((res) => {
          if (res.meta.code == 0) {
            this.userInfo = res.data
            window.sessionStorage.setItem('userUnifyInfo', JSON.stringify(res.data))
            localStorage.setItem('userUnifyInfo', JSON.stringify(res.data))
            this.$nextTick(() => {
              this.initFun()
            })
          } else {
            this.$toast(res.meta.message)
          }
        })
        .catch((err) => {
          this.$toast(err.meta.message)
        })
    },
  },
}
</script>

<style lang="less" scoped>
@import './home2.less';
</style>
